import { Box } from '@mui/material';
import DashboardNavLinks from 'component/DashboardNav/DashboardNavLinks';
import DashboardAddAssetButton from 'component/DashboardNav/DashboardAddAssetButton';

const BottomTab = () => (
  <Box
    sx={{
      fontSize: { xs: 10 },
      position: 'fixed',
      bottom: 25,
      left: '50%',
      transform: 'translateX(-50%)',
      display: { xs: 'flex', md: 'none' },
      border: '1px solid #fff',
      borderRadius: 5,
      overflow: 'hidden',
      maxWidth: '99vw',
      width: 'max-content',
      margin: 'auto',
      zIndex: 99,
    }}
  >
    <DashboardNavLinks variant="bottom" />
    <DashboardAddAssetButton variant="bottom" />
  </Box>
);

export default BottomTab;
